module.exports = __webpack_public_path__ + "static/img/Geos-2022-Marvin.d6ee911.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Geos-2022-Marvin.png
// module id = IIQP
// module chunks = 0